/**
 * Helper component to provide an HTML5 video
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';
import ReactJWPlayer from 'react-jw-player';

// import components
import Base from '../BaseComponent.js.jsx';

import * as userEventActions from '../../../modules/userEvent/userEventActions';
import * as sceneActions from '../../../modules/scene/sceneActions';

class VideoPlayer extends Base {
  constructor(props) {
    super(props);
    this._bind(
      '_onComplete'
      , '_onPause'
      , '_onPlay'
    )
  }

  componentWillUnmount() {
    /**
     * Invalidate the selected scene to prevent jwplayer from playing the previous
     * vid in the background when a new scene is loaded.
     *
     * PROBLEM: This has some unintended consequences. We want to invalidate the scene
     * when a user navigates to the next scene, HOWEVER, we don't want to invalidate
     * the scene EVERY time this component unmounts.
     * 
     * SOLUTION: Move the invalidateSelected action to the parent (ContentModuleNode) so that
     * it happens in componentWillReceiveProps and componentWillUnmount.
     */
    // this.props.dispatch(sceneActions.invalidateSelected())
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.playlist
      && nextProps.playlist[0]
      && nextProps.playlist[0].sources
      && nextProps.playlist[0].sources[0]
      && this.props.playlist
      && this.props.playlist[0]
      && this.props.playlist[0].sources
      && this.props.playlist[0].sources[0]
      && !_.isEqual(nextProps.playlist[0].sources[0], this.props.playlist[0].sources[0])
    )
  }


  // NOTE: see https://github.com/micnews/react-jw-player for more events
  _onPlay(e) {
    // console.log("VIDEO IS PLAYING!", this.props.playerId)
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "play"
      }));
    }
    if(this.props.onPlay) {
      // pass on to parent in case it has callbacks too
      this.props.onPlay(e);
    }
  }

  _onPause(e) {
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "pause"
      }));
    }
    if(this.props.onPause) {
      this.props.onPause(e);
    }
  }

  _onComplete(e) {
    if(!this.props.playlist[0].image) {
      let duration = window.jwplayer().getDuration();
      window.jwplayer(this.props.playerId).seek(duration);
    }
    if(this.props.tracking) {
      this.props.dispatch(userEventActions.sendCreateUserEvent({
        ...this.props.tracking // should contain any relevant keys to save
        , eventType: "video"
        , eventAction: "finish"
      }));
    }
    if(this.props.onComplete) {
      this.props.onComplete(e);
    }
  }
  
  render() {
    const { handleReady, isAutoPlay, isMuted, playerId, playlist } = this.props;

    // extract file path from playlist - i want to leave the playlist util stuff alone for now until we know we wont be reverting back to jw-player 
    const filePath = playlist && playlist[0] && playlist[0].sources && playlist[0].sources[0] && playlist[0].sources[0].file; 

    return(
      <div>
        {/* <ReactJWPlayer
          className="react-jw-player-wrapper"
          isAutoPlay={isAutoPlay}
          isMuted={isMuted}
          licenseKey="ARSuyOpWxi4Gq/3jm/hClEDvu5G7fswxhbY6rKg2jUo="
          onPlay={this._onPlay}
          onAutoStart={this._onPlay}
          onPause={this._onPause}
          onOneHundredPercent={this._onComplete}
          onReady={handleReady ? (e) => handleReady(playerId) : null}
          playerId={playerId}
          playerScript={'https://content.jwplatform.com/libraries/JKJ2bwkR.js'}
          playlist={playlist}
          // this works, but the choice doesn't appear to persist across loads
          customProps={{
            // playbackRateControls: true // use defaults, can specify array https://developer.jwplayer.com/jwplayer/docs/jw8-player-configuration-reference
            playbackRateControls: [0.5,0.75,1,1.25,1.5,2]

          }}
          
        /> */}
        <video 
          width="100%" 
          height="100%" 
          controls controlsList="nodownload" autoplay={`${isAutoPlay}`} muted={`${isMuted}`} playsinline="true"
          className='relative max-h-[70vh] w-full lg:w-4/5 mx-auto mt-8 z-10'>
          <source src={filePath} 
        />
        </video>
      </div>
    )
  }
}

VideoPlayer.propTypes = {
  dispatch: PropTypes.func.isRequired
  , handleReady: PropTypes.func // use to set jwPlayer controls from window
  , isAutoPlay: PropTypes.bool
  , isMuted: PropTypes.bool
  , onComplete: PropTypes.func
  , onPause: PropTypes.func
  , onPlay: PropTypes.func
  , playerId: PropTypes.string.isRequired
  , playlist: PropTypes.array
}

VideoPlayer.defaultProps = {
  handleReady: null
  , isAutoPlay: false
  , isMuted: false
  , onComplete: null
  , onPause: null
  , onPlay: null
  , playlist: null
}

export default connect()(VideoPlayer);



// WEBPACK FOOTER //
// global/components/helpers/VideoPlayer.js.jsx